import { render, staticRenderFns } from "./HistoryEmptyState.vue?vue&type=template&id=27931144&scoped=true&"
import script from "./HistoryEmptyState.vue?vue&type=script&lang=js&"
export * from "./HistoryEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEmptyState.vue?vue&type=style&index=0&id=27931144&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27931144",
  null
  
)

export default component.exports